export interface Breadcrumb {
    label: string,
    url: string | null
}
